"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/ApplicationManage");
var reactstrap_1 = require("reactstrap");
var ModalRegisterAppComponent = /** @class */ (function (_super) {
    __extends(ModalRegisterAppComponent, _super);
    function ModalRegisterAppComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageLoad: true,
            isOpen: false,
            appName: "",
            email: "",
            username: "",
            password: "",
            isSave: false,
            classSpinner: "d-none",
            version: 0
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        _this.SaveClick = _this.SaveClick.bind(_this);
        _this.handleChangeAppName = _this.handleChangeAppName.bind(_this);
        _this.handleChangeEmail = _this.handleChangeEmail.bind(_this);
        _this.handleChangeUsername = _this.handleChangeUsername.bind(_this);
        _this.handleChangePassword = _this.handleChangePassword.bind(_this);
        return _this;
    }
    ModalRegisterAppComponent.prototype.toggleModal = function () {
        this.setState({
            isOpen: !this.state.isOpen,
            classSpinner: "d-none",
            appName: "",
            email: "",
            username: "",
            password: ""
        });
        if (!this.state.isOpen) {
            this.props.afterCloseModalRegister();
        }
    };
    ModalRegisterAppComponent.prototype.handleChangeAppName = function (event) {
        this.setState({ appName: event.target.value });
    };
    ModalRegisterAppComponent.prototype.handleChangeEmail = function (event) {
        this.setState({ email: event.target.value });
    };
    ModalRegisterAppComponent.prototype.handleChangeUsername = function (event) {
        this.setState({ username: event.target.value });
    };
    ModalRegisterAppComponent.prototype.handleChangePassword = function (event) {
        this.setState({ password: event.target.value });
    };
    ModalRegisterAppComponent.prototype.SaveClick = function () {
        this.setState({
            isSave: true,
            classSpinner: "d-inline-block"
        });
        this.props.requestFunction(this.state.appName, this.state.email, this.state.username, this.state.password, "POST", this.state.version);
    };
    ModalRegisterAppComponent.prototype.render = function () {
        //console.log("isLoading - " + this.props.isLoading);
        //console.log("V State - " + this.state.version);
        //console.log("V Props - " + this.props.version);
        if (this.props.isLoading && this.state.isSave && this.props.version > this.state.version) {
            this.toggleModal();
            this.props.BindData();
            this.setState({
                isSave: false,
                classSpinner: "d-none",
                version: this.props.version
            });
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.toggleModal }, "Register Application"),
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.isOpen },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleModal }, "Register Application"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("label", { htmlFor: "txtAppName" },
                        React.createElement("b", null, "Application Name")),
                    React.createElement("input", { type: "text", id: "txtAppName", className: "form-control", value: this.state.appName, onChange: this.handleChangeAppName }),
                    React.createElement("label", { htmlFor: "txtEmail" },
                        React.createElement("b", null, "E-mail")),
                    React.createElement("input", { type: "text", id: "txtEmail", className: "form-control", value: this.state.email, onChange: this.handleChangeEmail }),
                    React.createElement("label", { htmlFor: "txtUsername" },
                        React.createElement("b", null, "Username")),
                    React.createElement("input", { type: "text", id: "txtUsername", className: "form-control", value: this.state.username, onChange: this.handleChangeUsername }),
                    React.createElement("label", { htmlFor: "txtPassword" },
                        React.createElement("b", null, "Password")),
                    React.createElement("input", { type: "password", id: "txtPassword", className: "form-control", value: this.state.password, onChange: this.handleChangePassword })),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "primary", onClick: this.SaveClick },
                        React.createElement(reactstrap_1.Spinner, { color: "primary", className: this.state.classSpinner, style: { width: '20px', height: '20px' } }),
                        ' ',
                        "Save"),
                    ' ',
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: this.toggleModal }, "Cancel")))));
    };
    return ModalRegisterAppComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.applicationManage; }, Stores.actionCreators)(ModalRegisterAppComponent);
//# sourceMappingURL=ModalRegisterAppComponent.js.map